<div *ngIf="formsContent.length > 0">
  <ng-container *ngFor="let formContent of formsContent">
    <app-form-constructor *ngIf="formContent" [formContent]="formContent"></app-form-constructor>
  </ng-container>
</div>
<button
  type="btn"
  data-test-id="btn-save-individual"
  (click)="openRoleSelectionModal()"
  [class]="isAdminSession ? 'btn btn-outline-secondary mt-3' : 'btn btn-outline-primary mt-3'"
  [disabled]="isAdminSession"
>
  {{ (formsContent.length > 0 ? 'INDIVIDUAL_MANAGE_ROLES_HINT' : 'INDIVIDUAL_ADD_ROLE_HINT') | translate }}
</button>
